import PropTypes from 'prop-types';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { withApollo } from 'react-apollo';

import { getUserAsset as GET_USER_ASSET } from 'GraphQL/query/Classroom.query';
import { updateUserAsset as UPDATE_USER_ASSET } from 'GraphQL/mutation/Classroom.mutation';
// import { useConfig } from 'Context/ConfigContext';

const ContentUserAsset = ({ assetReferId, children, client }) => {
  // const {
  //   classroom: { allowContentType },
  // } = useConfig();
  const {
    data: userAssetData,
    error: userAssetDataError,
    loading: isUserAssetDataLoading,
  } = useQuery(GET_USER_ASSET, {
    variables: { assetReferId },
    client,
    // NOTE: ANY-1653 For now, userAsset table does not exist in the database at all, it was implemented from PAAS project. So, if one day we need to use it, we need implement userAsset table first
    skip: true,
    // skip:
    //   !allowContentType.includes('NOTEBOARD') &&
    //   !allowContentType.includes('QUIZ_SIMPLE') &&
    //   !allowContentType.includes('LIVECODING'),
  });

  const [
    updateUserAsset,
    {
      data: updatedUserAssetData,
      error: updatedUserAssetError,
      loading: isUpdatedUserAssetLoading,
    },
  ] = useMutation(UPDATE_USER_ASSET, { client });
  const handleUpdateUserAsset = (userAssetDoc) => {
    updateUserAsset({ variables: { assetReferId, document: userAssetDoc } });
  };
  return children({
    userAssetDocument: userAssetData?.userAsset?.document,
    userAssetDataError,
    isUserAssetDataLoading,
    handleUpdateUserAsset,
    updatedUserAssetData,
    updatedUserAssetError,
    isUpdatedUserAssetLoading,
  });
};

ContentUserAsset.propTypes = {
  assetReferId: PropTypes.string,
};

export default withApollo(ContentUserAsset);
